import TableChartSidebar from 'components/Table/TableChartSidebar';
import { BatterReportChartConfigDto, BatterUsedPitchTypesDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const disabledVisibleStats: (keyof BatterUsedPitchTypesDto)[] = ['pitchType'];

const BatterUsedPitchTypesChartSidebar = (props: ChartConfigProps<TableChartConfigDto, BatterReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='BatterUsedPitchTypesChart'
      chartKey='batterUsedPitchTypesChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default BatterUsedPitchTypesChartSidebar;
